import React, { useContext } from 'react';
import {BsPlus,BsEyeFill} from 'react-icons/bs'
import { Link } from 'react-router-dom';
// import cart context
import { CartContext } from '../contexts/CartContext';
const Product = ({product}) => {
  const {addToCart}=useContext(CartContext);
  // console.log(product);
  const {image,price,title,category,id} =product;
  return <div
  className='  p-2'
  >
<div className='w-full flex flex-col justify-center items-center group border'>
  {/* image */}
  <div className='w-[150px] mx-auto flex justify-center items-center group transition cursor-pointer relative overflow-hidden'>
    <img src={image}
    className='max-h-[160px] group-hover:scale-110 transition duration-300'
    alt="product image" />
  </div>
  {/* buttons */}

  <div className='w-2/5 flex gap-2 p-4 items-center justify-center opacity-0 group-hover:opacity-100 transition-all'>
    {/* add to cart */}
    <button type="button" 
    onClick={()=>addToCart(product,id)}
    className='p-2 bg-black text-white rounded-md'
    ><BsPlus size={15}  /></button>
    <Link to={`/product/${id}`} className='p-2 bg-black text-white rounded-md'>
      <BsEyeFill size={15}/>
    </Link>
  </div>
</div>
{/* category item and price */}
<div className='flex flex-col'>
  <span className='text-sm capitalize text-gray-500 text-[15px] truncate'>{category}</span>
  <Link to={`/product/${id}`}>
  <span 
  className='font-medium mb-1 text-[14px]'
  >{title}</span>
  </Link>
  <div className='font-semibold text-[15px]'>$ {price}</div>
</div>

  </div>;
};

export default Product;
